import { classIf } from '../../../data/utils';
import { useParams } from '../../../router/Router';
import Link from '../../../router/Link';
import { getCategoryUrl, getTournamentUrl } from '../../Prematch';
import { useFilter } from '../../by-date/FilterProvider';

export default function CategoryCollapse(props) {
    const filter = useFilter();
    const c = props.data;
    const p = useParams();
    const uniqueId = `${p.sportId}_${p.categoryId}`;
    const toggled = c.uniqueId === uniqueId;

    function handleClick(e) {
        e.stopPropagation();
    }

    let tournaments = c.tournaments;
    if (filter != null) {
        tournaments = tournaments.filter(t => t.filters?.[filter] ?? true != null);
    }
    
    const tournamentsCount = c.tournamentsCount;
    
    return (
        <>
            <div className={"c_16_2" + classIf(toggled && (p.tournamentId == null), 'active')}>
                <div className={"c_16_2_1 " + c.categoryIcon}></div>
                <Link href={getCategoryUrl(c)} className="c_16_2_2"  onClick={handleClick}>{c.descrizione}</Link>
                <div className="c_16_2_3">
                    <div className="c_16_2_3_1">{tournamentsCount}</div>
                </div>
            </div>
            {toggled && tournaments.map(t => {
                const eventsCount = t.eventsCountByFilter?.[filter] ?? t.eventsCount

                return (
                    <Link key={t.id} href={getTournamentUrl(t)} className={"c_16_3" + classIf(toggled && p.tournamentId === t.id, 'active')} onClick={(e) => e.stopPropagation()}>
                        <div className="c_16_3_1">{t.desc}</div>
                        <div className="c_16_3_2">
                            <div className="c_16_3_2_1">{eventsCount}</div>
                        </div>
                    </Link>
                );
            })}
        </>
    );
}
